import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
var common = {
  reset: 'Reset',
  cancel: 'Cancel',
  confirm: 'OK',
  noData: 'No data',
  noSearchResult: 'No search results'
};
export default {
  ImageEdit: _Object$assign(_Object$assign({}, common), {
    replace: 'Replace',
    imageUpload: 'Upload image',
    picturePreview: 'Picture preview',
    imgClearVisible: '※ Please make sure the image is clearly visible',
    imgScale: 'Picture ratio',
    zoomIn: 'Enlarge',
    zoomOut: 'Narrow',
    rotateLeft: 'Rotate'
  }),
  Empty: {
    text: common.noData
  },
  LineFold: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  OrganizationPicker: _Object$assign(_Object$assign({}, common), {
    prompt: 'prompt',
    fail: 'fetch failed',
    chosen: 'You have chosen',
    items: 'items',
    click: 'Click to view',
    org: 'Organizational structure',
    chose: 'Choose organizational structure',
    search: 'Search organizational structure',
    pleaseChose: 'Please search',
    searchContent: 'Search content',
    loading: 'loading',
    chosenItems: 'Selected',
    empty: 'empty',
    city: 'City',
    cityGroup: 'CityGroup'
  }),
  Evaluation: {
    title: 'Did the above functions help you?',
    likeDesc: 'This is great, I like it!',
    dislikeDesc: 'Not satisfied. please continue optimizing...',
    feedbackDesc: 'Send Feedback'
  },
  MultiTableSelector: _Object$assign(_Object$assign({}, common), {
    rightText: 'Selected data',
    labelText: 'Please enter',
    search: 'Search'
  }),
  MultiTabSelector: _Object$assign(_Object$assign({}, common), {
    maxSelected: 'At most',
    ge: '',
    choose: 'Selected data',
    empty: 'Empty',
    chooseAll: 'Select all',
    labelText: 'Please enter',
    confirmEmpty: 'Are you sure to clear'
  }),
  CountDown: {
    confirm: 'ok',
    second: 's'
  },
  DateSelect: {
    customBtnText: "custom",
    leftRadioText: ['Yesterday', 'Last 7 days', 'Last 30 days', 'This month'],
    DefaultRightSelectorText: ['By day', 'By week', 'By month']
  }
};